import { render, staticRenderFns } from "./edit-file-settings.vue?vue&type=template&id=34b2dfaa"
import script from "./edit-file-settings.vue?vue&type=script&lang=js"
export * from "./edit-file-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports